import { type UpdateHookResponse, mutationUpdate } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useGameCache } from './cache'
import {
  type GamePartialUpdateInput,
  type GameUpdateInput,
  type GameUpdateSuccess,
  toResponseError,
  type GameData,
} from '@terros/common'

export function useUpdateGame(): UpdateHookResponse<GamePartialUpdateInput, GameData> {
  const cache = useGameCache()
  const mutation = useTantalimMutation<GameUpdateInput, GameUpdateSuccess>({ url: '/game/update' })

  async function update(game: GamePartialUpdateInput): Promise<GameData> {
    try {
      const { game: saved } = await mutation.mutateAsync({ game })
      cache.updateGameData(saved)
      return saved
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationUpdate(mutation, update)
}
